import AsyncStorage from '@react-native-async-storage/async-storage';

export const ASSISTANT_NAMES = [
  'Ananya',
  'Diya',
  'Meera',
  'Tara',
  'Kavya',
  'Nila',
  'Riya',
  'Aadhya',
] as const;

const CHAT_ROTATION_KEY = 'aiAssistantChatRotation';
const CURRENT_NAME_KEY = 'aiAssistantCurrentName';

/**
 * Get or compute the assistant name for this chat session.
 * Synchronously computes the time-of-day + rotation-based name on first call,
 * and persists it asynchronously via AsyncStorage for consistency across the session.
 */
export function useAssistantNameSync(now: Date = new Date()): string {
  // Compute synchronously based on time-of-day + rotation
  const timeSlot = now.getHours() * 60 + now.getMinutes();
  // Use a fixed rotation value for this session (computed once, not incremented)
  const sessionRotation = Math.floor(Math.random() * ASSISTANT_NAMES.length);
  const name = ASSISTANT_NAMES[(timeSlot + sessionRotation) % ASSISTANT_NAMES.length];
  return name;
}

/**
 * Persist and retrieve assistant name from AsyncStorage.
 * Call this in a useEffect to load a previously-saved name if it exists.
 */
export async function loadAssistantNameFromStorage(): Promise<string | null> {
  try {
    const saved = await AsyncStorage.getItem(CURRENT_NAME_KEY);
    if (saved && (ASSISTANT_NAMES as readonly string[]).includes(saved)) {
      return saved;
    }
  } catch {
    // Storage unavailable - return null and fall back to sync computation
  }
  return null;
}

/**
 * Save the current assistant name to AsyncStorage for persistence.
 */
export async function saveAssistantNameToStorage(name: string): Promise<void> {
  try {
    await AsyncStorage.setItem(CURRENT_NAME_KEY, name);
  } catch {
    // Storage unavailable - non-fatal
  }
}
